export default __webpack_public_path__ + "assets/images/bbda3d945b02e442b8738b97e1d3a91c.svg";